import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function CaseDetail4Page() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const processSteps = [
    {
      title: '到府現場評估',
      time: '搬家前 5 天',
      description: '專業人員到府評估物品數量，規劃最佳搬運路線和車輛',
      image: 'https://public.readdy.ai/ai/img_res/5de603eaee9709d05cb40c7e6c9f843b.jpg'
    },
    {
      title: '全屋打包作業',
      time: '搬家前 1 天',
      description: '專業團隊到府打包，所有物品分類裝箱並標記',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20packing%20entire%20household%20belongings%20in%20Taiwan%20home%2C%20organized%20labeled%20boxes%20by%20room%2C%20systematic%20packing%20process%20with%20quality%20materials%2C%20family%20home%20preparation%20for%20long%20distance%20move&width=800&height=600&seq=case-detail-4-step2&orientation=landscape'
    },
    {
      title: '大型家具保護',
      time: '搬家當天上午',
      description: '使用專業保護材料包裝大型家具，確保長途運輸安全',
      image: 'https://readdy.ai/api/search-image?query=Movers%20wrapping%20large%20furniture%20with%20protective%20blankets%20and%20plastic%20wrap%20for%20long%20distance%20transport%20in%20Taiwan%2C%20sofa%20bed%20wardrobe%20protection%2C%20professional%20furniture%20wrapping%20techniques&width=800&height=600&seq=case-detail-4-step3&orientation=landscape'
    },
    {
      title: '裝車固定作業',
      time: '搬家當天',
      description: '使用大型搬運車，物品有序裝載並固定，防止運輸中移動',
      image: 'https://readdy.ai/api/search-image?query=Professional%20movers%20loading%20furniture%20and%20boxes%20into%20large%20moving%20truck%20in%20Taiwan%20residential%20area%2C%20organized%20cargo%20arrangement%20with%20straps%20and%20padding%2C%20secure%20loading%20for%20long%20distance%20transport&width=800&height=600&seq=case-detail-4-step4&orientation=landscape'
    },
    {
      title: '長途安全運輸',
      time: '搬家當天',
      description: '專業司機駕駛，全程小心謹慎，確保物品安全送達',
      image: 'https://readdy.ai/api/search-image?query=Large%20moving%20truck%20driving%20on%20Taiwan%20highway%20from%20Taoyuan%20to%20destination%20city%2C%20professional%20long%20distance%20relocation%20service%2C%20safe%20cargo%20transport%20on%20scenic%20highway%20route&width=800&height=600&seq=case-detail-4-step5&orientation=landscape'
    },
    {
      title: '新居定位完成',
      time: '搬家當天傍晚',
      description: '按照客戶需求擺放家具，組裝拆卸的家具，完成驗收',
      image: 'https://readdy.ai/api/search-image?query=Movers%20arranging%20furniture%20in%20new%20Taiwan%20home%20after%20long%20distance%20relocation%2C%20happy%20family%20inspecting%20completed%20move%2C%20organized%20living%20room%20setup%2C%20successful%20cross-city%20moving%20completion&width=800&height=600&seq=case-detail-4-step6&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg 
        type="review" 
        data={{
          reviewRating: 5,
          reviewAuthor: '林先生',
          reviewDate: '2024-03-01',
          reviewText: '跨縣市搬家最怕物品損壞，建鈞搬家的長途搬運服務非常專業，所有家具都完好無損地送達新家。'
        }}
      />

      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-orange-500 to-amber-500 overflow-hidden">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 text-orange-100 mb-6">
            <Link to="/cases" className="hover:text-white transition-colors flex items-center gap-2">
              <i className="ri-arrow-left-line"></i>
              <span>返回案例列表</span>
            </Link>
            <span>/</span>
            <span className="text-white">案例詳情</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
                <i className="ri-truck-line"></i>
                <span>長途搬家</span>
              </div>

              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                桃園中壢跨縣市搬家
              </h1>

              <p className="text-xl text-orange-100 mb-8 leading-relaxed">
                林先生一家從桃園中壢搬到新北林口，30坪三房兩廳包含全套家具家電。我們提供完整的長途搬家服務，一天內完成跨縣市搬遷，所有物品完好無損。
              </p>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-orange-100 text-sm mb-1">客戶姓名</div>
                  <div className="text-white text-lg font-semibold">林先生</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-orange-100 text-sm mb-1">搬遷路線</div>
                  <div className="text-white text-lg font-semibold">中壢 → 林口</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-orange-100 text-sm mb-1">房屋坪數</div>
                  <div className="text-white text-lg font-semibold">30 坪</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-4">
                  <div className="text-orange-100 text-sm mb-1">搬遷費用</div>
                  <div className="text-white text-lg font-semibold">$18,000</div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-orange-400 to-amber-400 rounded-3xl blur-2xl opacity-30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20interior%20in%20Taiwan%20with%20complete%20furniture%20and%20household%20items%20ready%20for%20long%20distance%20relocation%2C%20organized%20family%20home%20with%20living%20room%20dining%20area%20and%20bedrooms%2C%20bright%20spacious%20residential%20space&width=800&height=600&seq=case-detail-4-hero&orientation=landscape"
                alt="桃園中壢跨縣市搬家"
                className="relative rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* 客戶評價 */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-8 md:p-12 shadow-lg">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-amber-500 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                林
              </div>
              <div>
                <div className="text-2xl font-bold text-gray-900">林先生</div>
                <div className="text-gray-600">三口之家</div>
                <div className="flex items-center gap-2 mt-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                  ))}
                  <span className="text-gray-600 font-semibold ml-2">5.0 分</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md">
              <div className="flex items-start gap-3">
                <i className="ri-double-quotes-l text-orange-600 text-4xl flex-shrink-0"></i>
                <div className="flex-1">
                  <p className="text-gray-700 text-lg leading-relaxed mb-4">
                    跨縣市搬家最怕物品損壞，建鈞搬家的長途搬運服務非常專業！他們事前做了詳細的評估和規劃，打包也很仔細。
                  </p>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    從中壢到林口雖然有一段距離，但師傅們開車很穩，所有家具家電都完好無損地送達新家。特別感謝他們幫忙組裝家具和擺放位置，讓我們當天就能入住，真的很感謝！
                  </p>
                </div>
                <i className="ri-double-quotes-r text-orange-600 text-4xl flex-shrink-0"></i>
              </div>
            </div>

            <div className="mt-6 flex items-center justify-between text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <i className="ri-calendar-line"></i>
                <span>2024年3月1日</span>
              </div>
              <div className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                跨縣市搬遷
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家過程 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">完整搬家流程</h2>
            <p className="text-xl text-gray-600">長途搬家，專業規劃確保安全</p>
          </div>

          <div className="space-y-16">
            {processSteps.map((step, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                  <div className="relative">
                    <div className="absolute -top-6 -left-6 w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg z-10">
                      {index + 1}
                    </div>
                    <img
                      src={step.image}
                      alt={step.title}
                      className="rounded-3xl shadow-2xl w-full h-96 object-cover object-top"
                    />
                  </div>
                </div>

                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                    <i className="ri-time-line"></i>
                    <span>{step.time}</span>
                  </div>

                  <h3 className="text-3xl font-bold text-gray-900 mb-4">{step.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>

                  <div className="mt-6 bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6">
                    <div className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-orange-600 text-2xl flex-shrink-0 mt-1"></i>
                      <div>
                        <div className="font-semibold text-gray-900 mb-2">專業服務重點</div>
                        <ul className="space-y-2 text-gray-700">
                          {index === 0 && (
                            <>
                              <li>• 詳細清點所有物品數量</li>
                              <li>• 評估大型家具搬運難度</li>
                              <li>• 規劃最佳運輸路線</li>
                            </>
                          )}
                          {index === 1 && (
                            <>
                              <li>• 提供充足紙箱和包裝材料</li>
                              <li>• 依房間分類裝箱標記</li>
                              <li>• 易碎品特殊包裝處理</li>
                            </>
                          )}
                          {index === 2 && (
                            <>
                              <li>• 沙發床墊專用保護套</li>
                              <li>• 木質家具防刮保護</li>
                              <li>• 家電防震包裝處理</li>
                            </>
                          )}
                          {index === 3 && (
                            <>
                              <li>• 重物放底部輕物放上方</li>
                              <li>• 使用綁帶固定防止移動</li>
                              <li>• 填充空隙避免碰撞</li>
                            </>
                          )}
                          {index === 4 && (
                            <>
                              <li>• 經驗豐富的專業司機</li>
                              <li>• 平穩駕駛避免急煞</li>
                              <li>• 全程監控貨物狀態</li>
                            </>
                          )}
                          {index === 5 && (
                            <>
                              <li>• 按平面圖擺放家具</li>
                              <li>• 組裝拆卸的家具</li>
                              <li>• 清理包裝材料垃圾</li>
                            </>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 長途搬家實拍 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-camera-line"></i>
              <span>真實記錄</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">長途搬家實拍照片</h2>
            <p className="text-xl text-gray-600">跨縣市搬遷，專業保障每一步</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Large%20L-shaped%20sofa%20being%20wrapped%20with%20thick%20protective%20blankets%20and%20plastic%20wrap%20for%20long%20distance%20move%20in%20Taiwan%20home%2C%20comprehensive%20furniture%20protection&width=400&height=400&seq=case4-real-1&orientation=squarish"
                alt="L型沙發包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">L型沙發包裝</p>
                  <p className="text-white/80 text-sm">全面包覆防止長途損傷</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Large%20wardrobe%20being%20carefully%20moved%20through%20doorway%20by%20professional%20movers%20in%20Taiwan%20apartment%2C%20coordinated%20large%20furniture%20handling&width=400&height=400&seq=case4-real-2&orientation=squarish"
                alt="大型衣櫃搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">大型衣櫃搬運</p>
                  <p className="text-white/80 text-sm">專業團隊協力搬運</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Refrigerator%20and%20washing%20machine%20wrapped%20with%20protective%20materials%20and%20secured%20on%20dolly%20for%20transport%20in%20Taiwan%20residential%20area&width=400&height=400&seq=case4-real-3&orientation=squarish"
                alt="家電保護搬運"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">家電保護搬運</p>
                  <p className="text-white/80 text-sm">防震包裝確保安全</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Large%203.5%20ton%20moving%20truck%20being%20loaded%20with%20furniture%20and%20boxes%20in%20Taiwan%20residential%20neighborhood%2C%20professional%20long%20distance%20moving%20vehicle&width=400&height=400&seq=case4-real-4&orientation=squarish"
                alt="大型搬運車裝載"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">大型搬運車裝載</p>
                  <p className="text-white/80 text-sm">3.5噸車一趟完成</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Furniture%20and%20boxes%20secured%20with%20straps%20inside%20moving%20truck%20cargo%20area%2C%20organized%20loading%20with%20padding%20between%20items%20for%20long%20distance%20transport&width=400&height=400&seq=case4-real-5&orientation=squarish"
                alt="貨物固定綁帶"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">貨物固定綁帶</p>
                  <p className="text-white/80 text-sm">綁帶固定防止移動</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Moving%20truck%20driving%20on%20Taiwan%20highway%20with%20scenic%20mountain%20background%2C%20professional%20long%20distance%20relocation%20transport%20on%20expressway&width=400&height=400&seq=case4-real-6&orientation=squarish"
                alt="高速公路運輸"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">高速公路運輸</p>
                  <p className="text-white/80 text-sm">專業司機平穩駕駛</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Movers%20unloading%20furniture%20from%20truck%20at%20high-rise%20apartment%20building%20in%20Taiwan%2C%20coordinated%20team%20working%20at%20new%20residence&width=400&height=400&seq=case4-real-7&orientation=squarish"
                alt="新居卸貨作業"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">新居卸貨作業</p>
                  <p className="text-white/80 text-sm">安全送達目的地</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Happy%20family%20in%20newly%20arranged%20living%20room%20after%20long%20distance%20move%20in%20Taiwan%20apartment%2C%20successful%20relocation%20completion%20with%20organized%20furniture&width=400&height=400&seq=case4-real-8&orientation=squarish"
                alt="搬遷完成驗收"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <p className="text-white font-semibold">搬遷完成驗收</p>
                  <p className="text-white/80 text-sm">客戶滿意入住新家</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 grid md:grid-cols-4 gap-6">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-truck-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">大型搬運車</h3>
              <p className="text-gray-600 text-sm">3.5噸車一趟完成</p>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">全程保險</h3>
              <p className="text-gray-600 text-sm">長途運輸有保障</p>
            </div>
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-route-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">30 公里運送</h3>
              <p className="text-gray-600 text-sm">中壢到林口安全送達</p>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 text-center">
              <div className="w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-white text-2xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">當天完成</h3>
              <p className="text-gray-600 text-sm">高效作業即日入住</p>
            </div>
          </div>
        </div>
      </section>

      {/* Google 客戶評論照片 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-google-fill"></i>
              <span>Google 評論</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">長途搬家客戶分享的真實照片</h2>
            <p className="text-xl text-gray-600">來自 Google 地圖評論的跨縣市搬遷紀錄</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20photo%20of%20large%20moving%20truck%20fully%20loaded%20for%20long%20distance%20relocation%20on%20Taiwan%20highway%2C%20real%20Google%20review%20image%20of%20cross-city%20moving%20service&width=400&height=400&seq=google-review-4-1&orientation=squarish"
                alt="客戶分享 - 滿載出發"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">林先生分享</p>
                  <p className="text-white/80 text-xs">一車搞定所有</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20showing%20furniture%20secured%20with%20straps%20inside%20moving%20truck%20for%20long%20distance%20transport%20in%20Taiwan%2C%20authentic%20cargo%20protection%20review&width=400&height=400&seq=google-review-4-2&orientation=squarish"
                alt="客戶分享 - 固定綁帶"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">陳太太分享</p>
                  <p className="text-white/80 text-xs">綁得很牢固</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20customer%20review%20photo%20of%20professional%20movers%20wrapping%20large%20wardrobe%20for%20cross-city%20relocation%20in%20Taiwan%2C%20real%20long%20distance%20moving%20documentation&width=400&height=400&seq=google-review-4-3&orientation=squarish"
                alt="客戶分享 - 衣櫃包裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">王先生分享</p>
                  <p className="text-white/80 text-xs">大衣櫃包得好</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20shared%20photo%20of%20moving%20truck%20arriving%20at%20new%20high-rise%20apartment%20building%20in%20Taiwan%20after%20long%20distance%20transport%2C%20real%20relocation%20completion%20review&width=400&height=400&seq=google-review-4-4&orientation=squarish"
                alt="客戶分享 - 安全抵達"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">張小姐分享</p>
                  <p className="text-white/80 text-xs">準時到達新家</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20of%20movers%20unloading%20furniture%20at%20new%20Taiwan%20residence%20after%20cross-city%20move%2C%20authentic%20long%20distance%20service%20documentation&width=400&height=400&seq=google-review-4-5&orientation=squarish"
                alt="客戶分享 - 卸貨作業"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">劉先生分享</p>
                  <p className="text-white/80 text-xs">卸貨很有效率</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Customer%20review%20photo%20showing%20all%20furniture%20intact%20after%20long%20distance%20move%20in%20Taiwan%20new%20home%2C%20real%20satisfied%20customer%20documentation%20of%20safe%20transport&width=400&height=400&seq=google-review-4-6&orientation=squarish"
                alt="客戶分享 - 完好無損"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">黃太太分享</p>
                  <p className="text-white/80 text-xs">東西都沒壞</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Authentic%20Google%20review%20photo%20of%20movers%20assembling%20bed%20frame%20in%20new%20Taiwan%20apartment%20after%20long%20distance%20relocation%2C%20real%20furniture%20reassembly%20service&width=400&height=400&seq=google-review-4-7&orientation=squarish"
                alt="客戶分享 - 家具組裝"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">周先生分享</p>
                  <p className="text-white/80 text-xs">還幫忙組裝床</p>
                </div>
              </div>
            </div>

            <div className="group relative overflow-hidden rounded-2xl shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Real%20customer%20photo%20of%20happy%20family%20in%20newly%20arranged%20living%20room%20after%20successful%20cross-city%20move%20in%20Taiwan%2C%20authentic%20satisfied%20customer%20review&width=400&height=400&seq=google-review-4-8&orientation=squarish"
                alt="客戶分享 - 入住新家"
                className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-1 mb-1">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-white font-semibold text-sm">吳先生分享</p>
                  <p className="text-white/80 text-xs">當天就入住了</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-xl p-8 mt-8">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-400 rounded-full flex items-center justify-center shadow-lg">
                  <i className="ri-google-fill text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">長途搬家好評</div>
                  <div className="flex items-center gap-2 mt-1">
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                      ))}
                    </div>
                    <span className="text-gray-600 font-semibold">5.0 跨縣市首選</span>
                  </div>
                </div>
              </div>
              <a
                href="https://maps.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-orange-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                <span>查看更多評論</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 搬家挑戰與解決方案 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">搬遷挑戰與解決方案</h2>
            <p className="text-xl text-gray-600">專業團隊，克服長途搬運難題</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center">
                  <i className="ri-alert-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">搬遷挑戰</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-red-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">搬運距離約 30 公里</div>
                      <p className="text-gray-600 text-sm">從中壢到林口，需要長途運輸</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-red-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">大型家具多</div>
                      <p className="text-gray-600 text-sm">L型沙發、雙人床、大衣櫃等需特殊處理</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-red-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">新家在 15 樓</div>
                      <p className="text-gray-600 text-sm">需要協調電梯使用時間</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-close-circle-fill text-red-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">必須當天完成</div>
                      <p className="text-gray-600 text-sm">客戶隔天要上班，時間緊迫</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-lightbulb-line text-white text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">解決方案</h3>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">使用 3.5 噸大型搬運車</div>
                      <p className="text-gray-600 text-sm">一趟完成所有物品運輸</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">專業保護包裝</div>
                      <p className="text-gray-600 text-sm">大型家具全面包覆，防止運輸損傷</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">提前協調大樓管理</div>
                      <p className="text-gray-600 text-sm">預約電梯專用時段，提高效率</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-md">
                  <div className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
                    <div>
                      <div className="font-semibold text-gray-900 mb-2">安排 4 位專業師傅</div>
                      <p className="text-gray-600 text-sm">充足人力確保當天完成</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-br from-orange-500 to-amber-500 rounded-3xl p-8 text-center shadow-2xl">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-trophy-line text-yellow-300 text-4xl"></i>
              <h3 className="text-3xl font-bold text-white">搬遷成果</h3>
            </div>
            <p className="text-xl text-orange-100 leading-relaxed max-w-3xl mx-auto">
              早上8點開始搬運，下午5點全部完成。30坪的家庭物品，包含L型沙發、雙人床、大衣櫃等大型家具，全部安全送達15樓新家。所有物品完好無損，客戶當晚就能入住新家，非常滿意我們的服務！
            </p>
          </div>
        </div>
      </section>

      {/* 長途搬家優勢 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">長途搬家優勢</h2>
            <p className="text-xl text-gray-600">跨縣市搬遷的專業選擇</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-truck-line text-orange-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">大型搬運車</h3>
              <p className="text-gray-600 text-center text-sm">3.5噸專業搬運車，一趟完成</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-shield-check-line text-amber-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">全程保險</h3>
              <p className="text-gray-600 text-center text-sm">長途運輸全程保險保障</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-box-3-line text-orange-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">專業包裝</h3>
              <p className="text-gray-600 text-center text-sm">防震防刮專業保護包裝</p>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-time-line text-amber-600 text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center mb-3">當天完成</h3>
              <p className="text-gray-600 text-center text-sm">高效作業，當天入住新家</p>
            </div>
          </div>
        </div>
      </section>

      {/* 更多案例 */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">查看更多成功案例</h2>
            <p className="text-xl text-gray-600">每個案例都是我們的承諾</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <Link to="/case-detail-1" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20interior%20in%20Taiwan%20with%20organized%20furniture%20and%20moving%20boxes%2C%20professional%20moving%20service%2C%20clean%20bright%20family%20living%20space&width=600&height=400&seq=more-case-long-1&orientation=landscape"
                    alt="家庭搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    家庭搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    新北板橋 3 房家庭搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">35坪家庭，鋼琴搬運零損傷</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-2" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20computers%20and%20business%20equipment%20being%20professionally%20moved%20in%20Taipei%20Taiwan%2C%20organized%20commercial%20relocation%20service&width=600&height=400&seq=more-case-long-2&orientation=landscape"
                    alt="辦公室搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    辦公室搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    台北信義區科技公司搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">50坪科技公司，48小時完成</p>
                </div>
              </div>
            </Link>

            <Link to="/case-detail-3" className="group">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2">
                <div className="h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Cozy%20studio%20apartment%20with%20organized%20personal%20belongings%20in%20New%20Taipei%20Taiwan%2C%20compact%20living%20space%20moving%20service&width=600&height=400&seq=more-case-long-3&orientation=landscape"
                    alt="套房搬遷"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <div className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm font-semibold inline-block mb-3">
                    套房搬遷
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-orange-600 transition-colors">
                    新北新莊套房搬遷
                  </h3>
                  <p className="text-gray-600 text-sm">8坪套房，全套打包服務</p>
                </div>
              </div>
            </Link>
          </div>

          <div className="text-center">
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 bg-orange-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-orange-600 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg"
            >
              <span>查看所有案例</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-orange-50 via-white to-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-white rounded-3xl shadow-2xl p-12">
            <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-800 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-map-pin-line"></i>
              <span>跨縣市搬家專家</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">長途搬家找建鈞</h2>
            <p className="text-xl text-gray-600 mb-8">
              專業規劃、安全運輸，讓您的物品完好送達
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/quote"
                className="bg-orange-500 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-orange-600 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg flex items-center justify-center gap-2"
              >
                <i className="ri-calculator-line text-xl"></i>
                <span>線上免費估價</span>
              </Link>

              <a
                href="tel:0978900081"
                className="bg-white border-2 border-orange-500 text-orange-500 px-10 py-4 rounded-full text-lg font-semibold hover:bg-orange-50 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>0978-900-081</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
